import React from "react";
import { HStack } from "@design-system/HStack/HStack";
import { DocumentIcon } from "@icons";
import { ChildrenProps } from "../../types";
import styles from "./DocumentsEmptyState.module.scss";

interface Props extends ChildrenProps {
    header?: React.ReactNode;
}

export const DocumentsEmptyState: React.FC<Props> = ({ header, children }) => (
    <section
        className={styles.container}
        data-testid="financial-documents-empty-state-section"
    >
        <aside className={styles.icon}>
            <DocumentIcon />
        </aside>

        <header>{header}</header>
        <HStack justify="center">{children}</HStack>
    </section>
);
